import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { BaseComponents } from "../base.component";
import { Router } from '@angular/router'
@Injectable()
export class GlobalErrorHandler extends BaseComponents implements ErrorHandler {
    constructor(private injector: Injector) {
        super(injector)
    }

    handleError(error: any): void {
        const router = this.injector.get(Router);
        const currentRoute = router.url;
        const isHttpError = error instanceof HttpErrorResponse
        const message = isHttpError ? `HTTP Error: ${error.status} ${error.message}` : error?.message || error.toString();
        this.logger.info(`Global Error url:${currentRoute} error message:${message}`)
        console.error('Global Error:',error);
    }
}